import React from 'react';
import { useParams } from 'react-router-dom';
import LeadDetailV2 from './LeadDetailV2';
import LeadOrganizationPanel from './LeadOrganizationPanel';
import './LeadOrganizationPanel.css';

// V2 compatibility entrypoint: Organization activity and Shared CRM context live in LeadDetailV2.
export default function LeadDetail() {
  const { id } = useParams();
  return <>
    <LeadDetailV2 />
    <div className="lead-v2-extension"><LeadOrganizationPanel leadId={id} /></div>
  </>;
}
